/**
 * 任务相关（包含任务组）
 */

import StoreDecorator, {
  Action,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  projectDetail
} from '../../api/worker';

interface StateType {
  taskList?: any;
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      taskList: {}
    };
  }

  // 项目详情
  @Action()
  public async projectDetail(state: StateType, payload: any) {
    return await projectDetail(payload);
  }
}

export default new StoreModule();
